//redux
import { useSelector } from "react-redux"

// *************************************************************
//     Misc

export function useCajaGasto() {
  return useSelector(state => state.Caja.context.gasto)
}

export function useCajaGastos() {
  return useSelector(state => state.Caja.context.gastos)
}

export function useEstadoCuenta() {
  return useSelector(state => state.Caja.context.estadoCuenta)
}

export function useReciboPago() {
  return useSelector(state => state.Caja.context.pago)
}

export function useDescuentosCatalogo() {
  return useSelector(state => state.Caja.context.descuentosCatalogo)
}

export function useDescuentosxidCuenta() {
  return useSelector(state => state.Caja.context.useDescuentosxidCuenta)
}

export function useGrupoServiciosEquivalentes() {
  return useSelector(state => state.Caja.context.grupoServiciosEquivalentes)
}

export function useFormasPagoSAT() {
  return useSelector(state => state.Caja.context.formasPagoSAT)
}

export function useUsosCFDI40() {
  return useSelector(state => state.Caja.context.usosCFDI40)
}

export function useCajaIdAlumno() {
  return useSelector(state => state.Caja.context.idAlumno)
}

export function useCajaoAlumno() {
  return useSelector(state => state.Caja.context.oAlumno)
}

export function useCajaError() {
  return useSelector(state => state.Caja.context.error)
}

export function useCajaIsLoading() {
  return useSelector(state => state.Caja.context.loading)
}

export function useCajaoRecibo() {
  return useSelector(state => state.Caja.context.oRecibo)
}

export function useCajaId_Recibo_Pago() {
  return useSelector(state => state.Caja.context.id_Recibo_Pago)
}

export function useCajaId_Relacion_Cuenta_Cargo() {
  return useSelector(state => state.Caja.context.id_Relacion_Cuenta_Cargo)
}

export function useCajaDataArmarReciboPago() {
  return useSelector(state => state.Caja.context.dataArmarReciboPago)
}

export function useCajaMensajeExitoso() {
  return useSelector(state => state.Caja.context.mensajeExitoso)
}

export function useCajaAlumnos() {
  return useSelector(state => state.Caja.context.alumnos)
}

export function useCajaServicios() {
  return useSelector(state => state.Caja.context.servicios)
}

export function useCajaoUltimoCargo() {
  return useSelector(state => state.Caja.context.oUltimoCargo[0])
}

export function useCajaoUltimoCargoIsLoading() {
  return useSelector(state => state.Caja.context.oCargoIsLoading)
}

export function useCajaIdServicioconDescuento(idServicio) {
  // Encontrar el grupo de servicios correspondiente al idGrupoServicios
  const gruposServicios = useSelector(
    state => state.Caja.context.grupoServiciosEquivalentes
  )
  const descuentos = useSelector(state => state.Caja.context.descuentosCatalogo)

  // Iterar sobre cada descuento para verificar si aplica
  for (const descuento of descuentos) {
    const idGrupo = descuento.id_Grupo_Servicios

    // Si el id_Grupo_Servicios es 0, aplica para cualquier servicio
    if (idGrupo === 0) {
      return true
    }

    // Buscar el grupo de servicios correspondiente al id_Grupo_Servicios
    const grupo = gruposServicios.find(
      grupo => grupo.id_Grupo_Servicios === idGrupo
    )

    // Si el grupo existe, verificar si el idServicio está en su lista de servicios
    if (
      grupo &&
      grupo.Lista_Servicios_.some(
        servicio => servicio.id_Servicio === idServicio
      )
    ) {
      return true
    }
  }
  // Si no se encuentra el servicio en ningún descuento válido, regresar false
  return false
}

export function useCajaRowsAffectedDelIdRelDesCargo() {
  return useSelector(state => state.Caja.context.rowsAffectedDelIdRelDescCargo)
}

export function useCajaRowsAffectedDeloCargo() {
  return useSelector(state => state.Caja.context.rowsAffectedDeloCargo)
}

export function useCajaIsProcessingDeloCargo() {
  return useSelector(state => state.Caja.context.isProcessingDeloCargo)
}

export function useCajaConceptosGasto() {
  return useSelector(state => state.Caja.context.conceptosGasto)
}

export function useCajaConceptosGastoOptions(elige = false) {
  const options = useSelector(state => state.Caja.context.conceptosGasto)
  let Options = options.map(option => {
    return {
      value: option.id_Concepto_Gasto,
      label: option.Nombre_Concepto_Gasto,
    }
  })
  if (elige) {
    // Agregar una opción "Elige" al inicio del arreglo
    Options.unshift({
      value: -1, // Puedes usar un valor especial que indique que es una selección predeterminada
      label: "Elige", // El texto que quieras mostrar en la opción por defecto
    })
  }
  return Options
}

export function useCajaConceptosGastoIsLoading() {
  return useSelector(state => state.Caja.context.gastoIsLoading)
}
